import { Table } from "@/features/Table";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { type C3DedicatedFund, useC3DedicatedFundColumns } from "./columns";
import {
  type FilterC3DedicatedFundsSchema,
  FilterC3DedicatedFunds,
} from "./filter";

export const C3DedicatedFundsTable = () => {
  const columns = useC3DedicatedFundColumns();
  return (
    <Table<C3DedicatedFund, FilterC3DedicatedFundsSchema>
      label="Fonds dédiés"
      client={Clients.C3}
      table_name={Tables.C3_DEDICATED_FUNDS}
      columns={columns}
      filter={<FilterC3DedicatedFunds />}
      actions={[
        {
          label: "actions.new",
          route: `${Clients.C3}/${Tables.C3_DEDICATED_FUNDS}/new`,
        },
      ]}
    />
  );
};
